import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import adminService from '../../utils/adminService';
import '../../styles/AdminDashboard.css';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    services: 0,
    activeServices: 0,
    bookings: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    setLoading(true);
    
    // Load services
    const servicesResult = await adminService.getServices();
    if (servicesResult.success) {
      const services = servicesResult.services;
      const activeServices = services.filter(s => s.isActive);
      
      setStats({
        services: services.length,
        activeServices: activeServices.length,
        bookings: 0 // TODO: Add bookings API
      });
    }

    setLoading(false);
  };

  if (loading) {
    return <div className="admin-loading">Loading dashboard...</div>;
  }

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1>Dashboard</h1>
        <p>Welcome to your admin panel</p>
      </div>

      <div className="dashboard-stats">
        <div className="stat-card">
          <div className="stat-icon">🔮</div>
          <div className="stat-info">
            <h3>Total Services</h3>
            <p className="stat-number">{stats.services}</p>
            <Link to="/admin/services" className="stat-link">Manage →</Link>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <div className="stat-info">
            <h3>Active Services</h3>
            <p className="stat-number">{stats.activeServices}</p>
            <Link to="/admin/services" className="stat-link">View →</Link>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">📅</div>
          <div className="stat-info">
            <h3>Total Bookings</h3>
            <p className="stat-number">{stats.bookings}</p>
            <Link to="/admin/bookings" className="stat-link">View →</Link>
          </div>
        </div>
      </div>

      <div className="dashboard-quick-actions">
        <h2>Quick Actions</h2>
        <div className="quick-actions-grid">
          <Link to="/admin/home-content" className="quick-action-card">
            <span className="action-icon">🏠</span>
            <h3>Edit Home Page</h3>
            <p>Update hero, features & testimonials</p>
          </Link>

          <Link to="/admin/services/new" className="quick-action-card">
            <span className="action-icon">➕</span>
            <h3>Add New Service</h3>
            <p>Create a new service offering</p>
          </Link>

          <Link to="/admin/services" className="quick-action-card">
            <span className="action-icon">📝</span>
            <h3>Manage Services</h3>
            <p>Edit prices, descriptions & images</p>
          </Link>

          <Link to="/admin/bookings" className="quick-action-card">
            <span className="action-icon">📅</span>
            <h3>View Bookings</h3>
            <p>Check upcoming appointments</p>
          </Link>

          <Link to="/admin/settings" className="quick-action-card">
            <span className="action-icon">⚙️</span>
            <h3>Settings</h3>
            <p>Configure your preferences</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
